import { render, staticRenderFns } from "./SignPositionSelector.vue?vue&type=template&id=0d6027be&scoped=true"
import script from "./SignPositionSelector.vue?vue&type=script&lang=js"
export * from "./SignPositionSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6027be",
  null
  
)

export default component.exports